import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChipInput from 'material-ui-chip-input';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function CreatePivot({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.CREATE-PIVOT.';
    // Initial states
    const [row, setRow] = useState(action.fields.rowTags?.value ? action.fields.rowTags.value : []);
    const [col, setCol] = useState(action.fields.colTags?.value ? action.fields.colTags.value : []);
    const [val, setVal] = useState(action.fields.values?.value ? action.fields.values.value : []);
    const [filter, setFilter] = useState(action.fields.filters?.value ? action.fields.filters.value : []);

    useEffect(() => {
        // Assign initial values
        if (!action.fields.tableRange) {
            action.fields.tableRange = { value: '', isRequired: true };
        }
    }, [action]);

    // Handle add a new tag
    const handleAdd = (chip, tag) => {
        let value;
        if (tag === 'filters') {
            value = [...filter, chip];
            setFilter(value);
        } else if (tag === 'rowTags') {
            value = [...row, chip];
            setRow(value);
        } else if (tag === 'colTags') {
            value = [...col, chip];
            setCol(value);
        } else {
            value = [...val, chip];
            setVal(value);
        }
        action.fields[tag] = { value };
    }
    // Handle delete a tag
    const handleDelete = (chip, tag) => {
        let value;
        if (tag === 'filters') {
            value = filter.filter((c) => c !== chip);
            setFilter(value);
        } else if (tag === 'rowTags') {
            value = row.filter((c) => c !== chip);
            setRow(value);
        } else if (tag === 'colTags') {
            value = col.filter((c) => c !== chip);
            setCol(value);
        } else {
            value = val.filter((c) => c !== chip);
            setVal(value);
        }
        action.fields[tag] = { value };
    }
    const style = { backgroundColor: '#fff', borderRadius: '5px', border: '1px solid gray', padding: '5px' };
    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + 'SELECT')}
                <TextInput action={action} inputName="tableRange" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired />
                <em className="form-element-eg">{t(label + 'SELECT-EG')}</em>
            </div>
            <div className="form-element">
                <div>{t(label + 'FIELDS')}</div>
                <em className="form-element-eg">{t(label + 'TAG-EG')}</em>
                <div style={{ marginTop: 8 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
                        <div style={{ marginBottom: 10, marginRight: 5 }}>
                            {t(label + 'FILTER')}
                            <ChipInput value={filter} onAdd={(chip) => {
                                handleAdd(chip, 'filters');
                            }}
                                onDelete={(chip, index) => {
                                    handleDelete(chip, 'filters');
                                }}
                                newChipKeyCodes={[188]} style={style} fullWidth
                            />
                        </div>
                        <div style={{ marginBottom: 10, marginLeft: 5 }}>
                            {t(label + 'ROW-TAG')}
                            <ChipInput value={row} onAdd={(chip) => {
                                handleAdd(chip, 'rowTags');
                            }}
                                onDelete={(chip, index) => {
                                    handleDelete(chip, 'rowTags');
                                }}
                                newChipKeyCodes={[188]} style={style} fullWidth
                            />
                        </div>
                        <div style={{ marginRight: 5 }}>
                            {t(label + 'COL-TAG')}
                            <ChipInput value={col} onAdd={(chip) => {
                                handleAdd(chip, 'colTags');
                            }}
                                onDelete={(chip, index) => {
                                    handleDelete(chip, 'colTags');
                                }}
                                newChipKeyCodes={[188]} style={style} fullWidth
                            />
                        </div>
                        <div style={{ marginLeft: 5 }}>
                            {t(label + 'VALUES')}
                            <ChipInput value={val} onAdd={(chip) => {
                                handleAdd(chip, 'values');
                            }}
                                onDelete={(chip, index) => {
                                    handleDelete(chip, 'values');
                                }}
                                newChipKeyCodes={[188]} style={style} fullWidth
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CreatePivot;
